import {
  ApiQuestBonus,
  ApiQuestBonusPayload,
  ApiQuestBonusTrigger,
} from "griptonite-api-client/types";
import { z } from "zod";

// The API's own label for a saved bonus is localised, but a trigger needs a name before
// there's a bonus to ask.
export const BONUS_TRIGGERS: { value: ApiQuestBonusTrigger; name: string }[] = [
  { value: "BETA_VIDEO", name: "Post a beta video" },
  { value: "GRADE_FEEDBACK", name: "Give grade feedback" },
  { value: "STAR_RATING", name: "Rate a climb" },
  { value: "TRAITS_VOTE", name: "Vote on route traits" },
];

export const BonusFormSchema = z.object({
  uuid: z.string().optional(),
  trigger: z.enum(["BETA_VIDEO", "GRADE_FEEDBACK", "STAR_RATING", "TRAITS_VOTE"], {
    message: "Choose what earns the side quest",
  }),
  creditReward: z
    .number({ message: "Credits required" })
    .int({ message: "Must be a whole number" })
    .min(1, { message: "Must be at least 1" }),
  // Empty means no limit.
  maxAwardsPerUser: z
    .number()
    .int({ message: "Must be a whole number" })
    .min(1, { message: "Must be at least 1" })
    .nullable(),
});

export type BonusFormValues = z.infer<typeof BonusFormSchema>;

export const bonusToFormValues = (
  bonus: ApiQuestBonus | undefined,
  availableTriggers: ApiQuestBonusTrigger[],
): BonusFormValues => {
  if (bonus) {
    return {
      uuid: bonus.uuid,
      trigger: bonus.trigger,
      creditReward: bonus.creditReward,
      maxAwardsPerUser: bonus.maxAwardsPerUser,
    };
  }
  // Not a valid value until chosen; the form's validation says so.
  const trigger = availableTriggers[0];
  return {
    uuid: undefined,
    trigger,
    creditReward: null as unknown as number,
    maxAwardsPerUser: null,
  };
};

export const bonusFormValuesToPayload = (values: BonusFormValues): ApiQuestBonusPayload => ({
  trigger: values.trigger,
  creditReward: values.creditReward,
  maxAwardsPerUser: values.maxAwardsPerUser,
});
